import { useEffect, useState } from 'react'
import SectionItem from '@components/Layout/SectionItem/SectionItem'
import './Distribution.scss'
import { useIntl } from 'react-intl'
import { LuxCheckboxInput, LuxIconSpinner } from '@lux/wardrobe-lib'
import { Approver } from '@/app/models/task'
import { connect } from 'react-redux'
import { NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE } from '@/app/redux/reducers/activity-creation'
import { NewActivitySectionType } from '@/app/models/new-activity-section-type'

const ApproversListComponent = (props: {
    approversList: Approver[]
    setApproversList: (val: Approver[]) => void
    loading: boolean
    selectedRecipients: any[]
    mandatory?: boolean
    surveyList: any
    taskList: any
}) => {
    const {
        approversList,
        setApproversList,
        loading,
        selectedRecipients,
        mandatory,
        surveyList,
        taskList,
    } = props

    const intl = useIntl()

    const regionalManagers = ['RM', 'ZD', 'ZVP', 'ROM', 'RDE']
    const [isSelectAll, setIsSelectAll] = useState(false)
    const [disableRegionalManager, setDisableRegionalManager] = useState(
        !!selectedRecipients?.includes('regionalmanager')
    )
    const [actionRecipients, setActionRecipients] = useState([])

    useEffect(() => {
        let _actionRecipients = []
        if (surveyList?.length || taskList?.length) {
            surveyList?.map((s) => {
                if (s.recipient) _actionRecipients.push(s.recipient)
            })
            taskList?.map((s) => {
                if (s.recipient) _actionRecipients.push(s.recipient)
            })
        }
        setActionRecipients(_actionRecipients)
    }, [surveyList, taskList])

    useEffect(() => {
        let _allRecipientsList = actionRecipients.concat(selectedRecipients || [])
        setDisableRegionalManager(!!_allRecipientsList.includes('regionalmanager'))
        if (_allRecipientsList?.length === 0) {
            setApproversList(
                approversList.map((na) => ({
                    ...na,
                    selected: false,
                }))
            )
        }
    }, [selectedRecipients, actionRecipients])

    useEffect(() => {
        if (disableRegionalManager && approversList?.length) {
            setApproversList(
                approversList.map((na) => ({
                    ...na,
                    selected: regionalManagers.includes(na.role) ? false : na.selected,
                }))
            )
        }
    }, [disableRegionalManager])

    useEffect(() => {
        if (approversList?.length) {
            setIsSelectAll(
                approversList.filter((a) => a.selected)?.length ==
                    (disableRegionalManager
                        ? approversList.filter((a) => !regionalManagers.includes(a.role))?.length
                        : approversList?.length)
            )
        }
    }, [approversList])

    return (
        <SectionItem>
            <label className="approvers-roles-label">
                {mandatory && <span className="mandatory">*</span>}
                <span className="text-bold">
                    {intl.formatMessage({
                        id: 'ph2.modals.new.activity.creation.distribution.approvers_roles',
                        defaultMessage: 'Approvers roles',
                    })}
                </span>
            </label>
            {loading ? (
                <LuxIconSpinner />
            ) : (
                <div className="flex flex-column">
                    <LuxCheckboxInput
                        classes="mt-3 mb-3 bold"
                        label={intl.formatMessage({
                            id: 'modals.filters.label.all',
                            defaultMessage: 'All',
                        })}
                        value={isSelectAll}
                        disabled={!selectedRecipients || selectedRecipients?.length == 0}
                        onChangeCallback={(v: boolean) => {
                            setApproversList(
                                approversList.map((na) => ({
                                    ...na,
                                    selected:
                                        v &&
                                        (!disableRegionalManager ||
                                            !regionalManagers.includes(na.role)),
                                }))
                            )
                        }}
                    />
                    {approversList.map((a, i) => (
                        <LuxCheckboxInput
                            key={i}
                            classes="mt-3"
                            label={
                                // intl.formatMessage({ id: `ph2.approver_role.${a.role}`, defaultMessage:
                                `${a.role} - ${a.name}`
                                // ,})
                            }
                            disabled={
                                (disableRegionalManager && regionalManagers.includes(a.role)) ||
                                !selectedRecipients ||
                                selectedRecipients?.length == 0
                            }
                            value={a.selected || false}
                            onChangeCallback={(v) => {
                                setApproversList(
                                    approversList.map((na) => ({
                                        ...na,
                                        selected: na.role === a.role ? v : na.selected,
                                    }))
                                )
                            }}
                        />
                    ))}
                </div>
            )}
        </SectionItem>
    )
}

const mapStateToProps = (state: any) => ({
    taskList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].taskList,
    surveyList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].surveyList,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ApproversListComponent)
